/**
 * @returns true if any cart product has a special/deal
 */
export const hasSpecial = (
  products: ReadonlyArray<{ special_id?: number | null }>
) => {
  return products.some(({ special_id }) => !!special_id);
};
